import styles from './ToolBody.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export const ToolBody = _ref => {
  let {
    children,
    'aria-labelledby': ariaLabelledBy,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("section", {
    "aria-labelledby": ariaLabelledBy,
    className: styles.toolBody,
    ...rest,
    children: children
  });
};